import React, { memo } from "react"
import moment from "moment"
import { PROCESS_REPEAT, JOB_PINNING } from "../../data"
import { useDateUtils, useProcessUtils } from "../../utils"
import { FormatDateCompact } from "../Format"

const typename = "__typename"

const ProcessScheduleStatement = ({ process }) => {
  const { hasTime, scheduleDateToMoment, formatScheduleTime, formatTime } = useDateUtils()
  const { getRepeatProcessTypeData } = useProcessUtils()

  const {
    pinning,
    after: afterInput,
    due: dueInput,
    repeat: { type, frequency, weekdays, months },
  } = process

  const typeData = getRepeatProcessTypeData(type)
  const selectedWeekdays = Object.keys(weekdays).filter((weekday) => weekday !== typename && weekdays[weekday])
  const selectedMonths = Object.keys(months).filter((month) => month !== typename && months[month])

  const after = scheduleDateToMoment(afterInput)
  const due = scheduleDateToMoment(dueInput)

  // determine pinning if enabled
  const { type: pinningType, period: pinningPeriod } = pinning
  const pinned = pinningType !== JOB_PINNING.NONE
  let pinnedStatement
  switch (pinningType) {
    case JOB_PINNING.NEXT_INSTANCE:
      pinnedStatement = (
        <>
          active until <strong>the next scheduled instance</strong>
        </>
      )
      break
    case JOB_PINNING.HOURS: {
      const pinnedUntil = moment(after).add(pinningPeriod, "hours")
      pinnedStatement = (
        <>
          active until <FormatDateCompact value={pinnedUntil} /> at <strong>{formatTime(pinnedUntil)}</strong>
        </>
      )
      break
    }
    case JOB_PINNING.DAYS: {
      const pinnedUntil = moment(after).endOf("day").add(pinningPeriod, "days")
      pinnedStatement = (
        <>
          active until <FormatDateCompact value={pinnedUntil} /> at <strong>{formatTime(pinnedUntil)}</strong>
        </>
      )
      break
    }
    default:
      pinnedStatement = "active until complete"
  }

  // const pinnedUntil = pinned && pinnedMinutes ? moment(after).add(pinnedMinutes, "minutes") : null

  // const pinnedStatement = (() => {
  //   const { type: pinningType, period: pinningPeriod } = pinning
  //    return pinnedUntil ? (
  //   <>
  //     active until <FormatDateCompact value={pinnedUntil} /> at <strong>{formatTime(pinnedUntil)}</strong>
  //   </>
  // ) : (
  //   "active until complete"
  // )
  // })()

  return (
    <>
      This process{" "}
      {after && (
        <>
          will start on{" "}
          <strong>
            <FormatDateCompact value={after} />
          </strong>
        </>
      )}
      {hasTime(after) && (
        <>
          {" "}
          at <strong>{formatScheduleTime(afterInput)}</strong>
        </>
      )}
      {due && (
        <>
          , due at <strong>{formatScheduleTime(dueInput)}</strong>
        </>
      )}
      {pinned && ![PROCESS_REPEAT.NEVER, PROCESS_REPEAT.ADHOC].includes(type) && (
        <>
          , will remain <strong>{pinnedStatement}</strong>,
        </>
      )}
      {type === PROCESS_REPEAT.NEVER && (
        <>
          {pinned && (
            <>
              , will remain <strong>{pinnedStatement}</strong>,
            </>
          )}{" "}
          and <strong>{typeData.label.toLowerCase()}</strong>
        </>
      )}
      {type === PROCESS_REPEAT.ADHOC && (
        <>
          is run on an <strong>ad hoc</strong> basis
          {pinned && (
            <>
              {" "}
              and will remain <strong>{pinnedStatement}</strong>
            </>
          )}
        </>
      )}
      {![PROCESS_REPEAT.NEVER, PROCESS_REPEAT.ADHOC].includes(type) && (
        <>
          {" "}
          and will repeat{" "}
          {frequency > 1 && (
            <strong>
              every {frequency} {typeData.plural.toLowerCase()}
            </strong>
          )}
          {frequency === 1 && (
            <>
              on a <strong>{typeData.label.toLowerCase()}</strong> basis
            </>
          )}
          {selectedWeekdays.length > 0 && (
            <>
              {" "}
              on{" "}
              {selectedWeekdays.map((weekday, index) => (
                <span key={weekday}>
                  {index ? ", " : ""}
                  <strong>
                    {weekday.substring(0, 1).toUpperCase()}
                    {weekday.substring(1)}
                  </strong>
                </span>
              ))}
            </>
          )}
          {selectedMonths.length > 0 && (
            <>
              {" "}
              in{" "}
              {selectedMonths.map((month, index) => (
                <span key={month}>
                  {index ? ", " : ""}
                  <strong>
                    {month.substring(0, 1).toUpperCase()}
                    {month.substring(1)}
                  </strong>
                </span>
              ))}
            </>
          )}
        </>
      )}
      .
    </>
  )
}

const ProcessScheduleStatementMemo = memo(ProcessScheduleStatement)

export { ProcessScheduleStatementMemo as ProcessScheduleStatement }
